import React from "react";
import Layout from "Components/Layouts/Common/common";
import AboutClasses from "./styles.module.css";
import About3 from "Assets/About/about_3.png";
import Image1 from "Assets/About/about_1.png";
import About_2 from "Assets/About/about_2.png";
import AboutCard from "Components/AboutUs/Cards/Cards";
function About() {
    return (
        <Layout>
            <div className={AboutClasses["Container"]}>
                <header>
                    <h3>Annual filing or Franchise taxes</h3>
                </header>

                <div className={AboutClasses["section-1"]}>
                    <div className={AboutClasses["content"]}>
                        <h3>
                            Stay Compliant and Keep Your Business in Good
                            Standing.
                        </h3>
                        <p>
                            At <b>Serene Tax</b>, we specialize in helping
                            businesses navigate the complexities of{" "}
                            <b>annual filings</b> and{" "}
                            <b>franchise tax requirements.</b>
                            Whether you're a corporation, LLC, or partnership,
                            our expert team ensures your business stays
                            compliant with all federal, state, and local
                            regulations, avoiding penalties and maintaining your
                            good standing.
                        </p>
                    </div>
                    <img src={Image1} alt="user" />
                </div>

                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About_2} alt="user" />
                    <div className={AboutClasses["content"]}>
                        {/* <h5>Who we are</h5>{" "} */}
                        <h3>What Are Annual Filings and Franchise Taxes?</h3>
                        <p>
                            <b> Annual Filings:</b> Most businesses are required
                            to submit annual reports to state authorities,
                            updating key information such as the company’s
                            address, directors, and registered agent. These
                            filings are necessary to keep your business entity
                            active and in compliance with state laws
                        </p>
                        <p>
                            <b>Franchise Taxes:</b> Many states impose a
                            franchise tax on businesses for the privilege of
                            operating within the state. Franchise taxes are
                            typically based on your business's income, net
                            worth, or a flat fee, depending on state
                            regulations.
                        </p>
                    </div>
                </div>
                <div className={AboutClasses["section-1"]}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>
                            Why Are Annual Filings and Franchise Taxes
                            Important?
                        </h3>
                        <p>
                            <b>1. Maintain Compliance:</b>Failing to file annual
                            reports or pay franchise taxes can lead to
                            penalties, interest, or even the suspension or
                            dissolution of your business entity.
                        </p>
                        <p>
                            <b>2.Avoid Penalties:</b>
                            Late or missed filings often incur significant
                            fines, which can hurt your bottom line.
                        </p>
                        <p>
                            <b>3.Preserve Business Credibility:</b>
                            Staying compliant helps maintain your business's
                            reputation and good standing with state and federal
                            authorities.
                        </p>
                        <p>
                            <b>4.Avoid Legal Issues:</b> Proper filings ensure
                            your business remains legally authorized to operate.
                        </p>
                    </div>
                    <img src={About3} alt="user" />
                </div>
                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About3} alt="user" />
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>How Serene Tax Can Help</h3>
                        <p>
                            <b>1. Accurate Annual Reports</b>
                            <br />
                            We handle the preparation and submission of your
                            business's annual reports, ensuring all required
                            information is accurate and filed on time
                        </p>
                        <p>
                            <b>2. Franchise Tax Preparation</b>
                            <br />
                            Our team calculates and prepares your franchise tax
                            returns based on state-specific requirements,
                            ensuring compliance and minimizing tax liabilities.
                        </p>
                        <p>
                            <b>3. Deadline Monitoring</b>
                            <br />
                            We keep track of filing and payment deadlines so you
                            never have to worry about missing an important date.
                        </p>
                        <p>
                            <b>4. Ongoing Compliance Support</b> <br />
                            Annual and franchise tax requirements can vary by
                            state and business structure. Our experts stay
                            updated on the latest changes to ensure your
                            business remains compliant year-round.
                        </p>
                    </div>
                </div>
                <div className={AboutClasses["section-1"]}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>
                            Who Needs Annual Filing and Franchise Tax Services?
                        </h3>
                        <p>
                            <b>1.Corporations:</b>
                            <br />
                            C-corporations and S-corporations are typically
                            required to file annual reports and pay franchise
                            taxes in the states where they are incorporated or
                            do business.
                        </p>
                        <p>
                            <b>2.LLCs:</b>
                            <br />
                            Many states require LLCs to submit annual reports
                            and pay franchise taxes or alternative fees.
                        </p>
                        <p>
                            <b>3.Partnerships:</b>
                            <br />
                            While not all partnerships are subject to franchise
                            taxes, many must file annual reports.
                        </p>
                        <p>
                            <b>4.Nonprofits:</b>
                            <br />
                            Certain nonprofits may also be required to file
                            annual reports and pay franchise fees depending on
                            their activities and state requirements.
                        </p>
                    </div>
                    <img src={About3} alt="user" />
                </div>
                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About3} alt="user" />
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Our Process</h3>
                        <p>
                            <b>1.Initial Assessment:</b>
                            <br />
                            We’ll review your business structure and state of
                            incorporation to determine your specific annual
                            filing and franchise tax requirements.
                        </p>
                        <p>
                            <b>2.Document Preparation:</b>
                            <br />
                            Our team gathers and organizes the necessary
                            documents, ensuring all filings are accurate and
                            complete.
                        </p>
                        <p>
                            <b>3.Filing and Payment:</b>
                            <br />
                            We prepare and submit your annual report and
                            franchise tax payments on time, helping you avoid
                            penalties and keep your business in good standing.
                        </p>
                        <p>
                            <b>4.Year-Round Monitoring:</b>
                            <br />
                            Compliance doesn’t stop after a single filing. We
                            provide ongoing support to ensure you’re always
                            prepared for future filings and tax requirements.
                        </p>
                    </div>
                </div>
                <div className={AboutClasses["section-1"]}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Why Choose Serene Tax?</h3>
                        <p>
                            <b>Expert Knowledge:</b> Our team is well-versed in
                            the varying annual filing and franchise tax
                            requirements across different states.
                        </p>
                        <p>
                            <b>Timely and Accurate Filing: </b>We handle all
                            filings and payments with precision to keep your
                            business compliant and penalty-free.
                        </p>
                        <p>
                            <b>Custom Solutions:</b>
                            We tailor our services to your business’s unique
                            needs, whether you’re a small LLC or a multi-state
                            corporation.
                        </p>
                        <p>
                            <b>Proactive Compliance:</b>
                            We monitor deadlines and changes to tax laws,
                            ensuring your business stays ahead of any compliance
                            issues.
                        </p>
                        <p>
                            <b>Stress-Free Process: </b>: We simplify the
                            process so you can focus on running your business
                            while we take care of the paperwork.
                        </p>
                    </div>
                    <img src={About3} alt="user" />
                </div>
                <div
                    className={AboutClasses["section-1"]}
                    style={{ gridTemplateColumns: "1/-1" }}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Frequently Asked Questions ?</h3>
                        <h4>
                            1. What happens if I miss my annual filing or
                            franchise tax deadline?
                        </h4>
                        <p>
                            Missing deadlines can result in penalties, interest,
                            or even the suspension of your business entity. Our
                            team ensures this doesn’t happen by filing on time.
                        </p>
                        <h4>
                            2. Do all businesses have to pay franchise taxes?
                        </h4>
                        <p>
                            Franchise tax requirements vary by state and
                            business structure. Some states charge a flat fee,
                            while others base it on income or net worth. We’ll
                            assess your specific requirements.
                        </p>
                        <h4>
                            3. Can Serene Tax file annual reports for
                            multi-state businesses?
                        </h4>
                        <p>
                            Yes! We assist businesses operating in multiple
                            states with their annual filings and franchise tax
                            obligations, ensuring compliance across all
                            jurisdictions.
                        </p>
                        <h4>4. How can I lower my franchise tax liability? </h4>
                        <p>
                            Our team can help you identify potential tax-saving
                            opportunities based on your business structure and
                            state regulations.
                        </p>
                    </div>
                </div>
                <div
                    className={AboutClasses["section-1"]}
                    style={{ gridTemplateColumns: "1fr" }}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>
                            Let Serene Tax Handle Your Annual Filing and
                            Franchise Taxes
                        </h3>
                        <p>
                            Avoid the stress of managing compliance deadlines
                            and complex tax calculations. At ,<b>Serene Tax</b>,
                            we make annual filings and franchise taxes easy and
                            hassle-free
                            <br />
                            Contact us today for a consultation.{" "}
                            <b>Call [+1 (262) 735-8874/ +1 (262) 735- 8875]</b>
                        </p>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default About;
